export const contactValidate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Name is required!";
  } else if (values.name.length < 2) {
    errors.name = "Name must be at least 2 characters long!";
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  if (!values.email) {
    errors.email = "Email is required!";
  } else if (!emailRegex.test(values.email)) {
    errors.email = "Email is not valid!";
  }

  return errors;
};
